// extracted by mini-css-extract-plugin
export default {"stdTile":"styles_stdTile__DViN+","featured":"styles_featured__i4h11","bonus":"styles_bonus__8Z7KB","leMag":"styles_leMag__lU5+6","featured16By9":"styles_featured16By9__9nITy"};